import http from "../../../util/axios";

export default {
  countryList(params) {
    return http.get("/country/list", { params });
  },
  // 账号密码登录
  login(data) {
    return http.post("/login", data);
  },
  //手机号密码登录
  phoneLogin(data) {
    return http.post("/phoneLogin", data);
  },
  //手机号验证码登录
  smsLogin(data) {
    return http.post("/smsLogin", data);
  },
  mailSend(params) {
    return http.get("/mail/send", { params });
  },
  //手机号重置密码
  phoneResetPassword(data) {
    return http.post("/phoneResetPassword", data);
  },
  //邮箱重置密码
  mailResetPassword(data) {
    return http.post("/mailResetPassword", data);
  },
  //获取验证码（国内）
  smsGetInternalSmsCode(params) {
    return http.get("/sms/getInternalSmsCode", { params });
  },
  //选择身份
  selectIdentity(params) {
    return http.get("/selectIdentity", { params });
  },
  // 获取极验配置参数
  getGeetestConfig(params) {
    return http.get("/gt/register?t=" + Date.now(), {
      params,
      baseURL: process.env.gt
    });
  },
  // 极验二次校验
  validateGeetest(params) {
    return http.get("/gt/validate", {
      params,
      baseURL: process.env.gt
    });
  },
  //切换项目
  switchLearn(params) {
    return http.get("/app/user/center/switchLearn", { params });
  },
  //切换项目
  teacherSwitchLearn(params) {
    return http.get("/app/teacher/center/switchClass", { params });
  },
  //登陆成功后获取用户项目
  getClassList(params) {
    return http.get("/app/user/center/getClassList", { params });
  },
  //登陆成功后获取用户项目
  teacherGetClassList(params) {
    return http.get("/app/teacher/center/getClassList", { params });
  },
  //获取 学生端导航栏图片
  getUserLoginImg() {
    return http.get("/commonSetting/getUserLoginImg");
  },
  // 获取备案号
  getFilingNo() {
    return http.get("/org/getFilingNo");
  }
};



// WEBPACK FOOTER //
// ./src/api/user/login/index.js